import { get } from 'lodash'

import { getBrandName } from '../../config'
import { StorefrontData } from '../redux/models/StorefrontData'
import { Analytics } from './index'

export function pushStorefrontDataToDatalayer(storefrontData: StorefrontData): void {
  const numberOfOrderedCars = get(storefrontData, 'financialProduct.numberOfOrderedCars')

  const payload: Record<string, unknown> = {
    'product[0].attributes.duration': get(storefrontData, 'financialProduct.calculation.duration'),
    'product[0].attributes.durationUnit': get(
      storefrontData,
      'financialProduct.calculation.durationUnit'
    ),
    'product[0].attributes.yearlyMileage': get(
      storefrontData,
      'financialProduct.calculation.yearlyMileage'
    ),
    'product[0].attributes.recurringPayment': get(
      storefrontData,
      'financialProduct.calculation.subsequentInstallmentTotalAmount.amount'
    ),
    'product[0].attributes.balloonPayment': get(
      storefrontData,
      'financialProduct.calculation.balloonPaymentAmount.amount'
    ),
    'product[0].attributes.contractAmount': get(
      storefrontData,
      'financialProduct.calculation.netLoan.amount'
    ),
    'product[0].attributes.netLoanAmount': get(
      storefrontData,
      'financialProduct.calculation.netLoan.amount'
    ),
    'product[0].attributes.downPaymentAmount': get(
      storefrontData,
      'financialProduct.calculation.downPaymentAmount.amount'
    ),
    'product[0].attributes.nominalInterestRate': get(
      storefrontData,
      'financialProduct.calculation.nominalInterestRate'
    ),
    'product[0].attributes.nominalInterestAmount':
      ((get(storefrontData, 'financialProduct.calculation.nominalInterestRate') as number) *
        (get(storefrontData, 'financialProduct.calculation.netLoan.amount') as number)) /
      100,
    'product[0].attributes.effectiveInterestRate': get(
      storefrontData,
      'financialProduct.calculation.effectiveInterestRate'
    ),
    'product[0].vehicleModel[0].manufacturer': get(storefrontData, 'vehicleData.vehicleModel.name'),
    'product[0].vehicleModel[0].name': get(storefrontData, 'vehicleData.vehicleModel.manufacturer'),
    'product[0].vehicleModel[0].descriptionLong': get(
      storefrontData,
      'vehicleData.model.descriptionLong'
    ),
    'product[0].vehicleModel[0].salesId': get(storefrontData, 'vehicleData.model.descriptionLong'),
    'product[0].vehicleModel[0].colorExterior': get(
      storefrontData,
      'vehicleData.model.colorExterior'
    ),
    'product[0].vehicleModel[0].endPrice_localCurrency': get(
      storefrontData,
      'vehicleData.retailPriceAmount.grossAmount'
    ),
    'customerData.loginStatus': true,
    'core.attributes.brand': getBrandName().toUpperCase()
  }

  if (numberOfOrderedCars) {
    payload['product[0].attributes.recurringPayment'] =
      (get(storefrontData, 'financialProduct.calculation.subsequentInstallmentTotal') as number) *
      (numberOfOrderedCars as number)
  } else {
    payload['product[0].attributes.recurringPayment'] = get(
      storefrontData,
      'financialProduct.calculation.subsequentInstallmentTotal'
    )
  }

  Analytics.addToDatalayer(payload)
}
